// One browser-side validator for wire dates: exactly `YYYY-MM-DD` and
// calendar-valid. Shared by the billing normalizer and the homework
// helpers so a malformed or time-suffixed value is never read as a date
// by lexicographic accident.
export function wireDateIsValid(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
  const parsed = new Date(`${value}T00:00:00Z`)
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value
}
